import { useEffect, useState } from "react";
import frame30 from "../../assets/images/Frame-30.png";

export default function PanelTop({ content, updateContent, coinList }) {
  const [selectedCoin, setSelectedCoin] = useState(content.coinName);
  useEffect(() =>{
   setSelectedCoin(content.coinName)
  },[content])
  useEffect(() => {
    // Update selected coin's details when `content.coinName` changes
    const coinData = coinList.find((coin) => coin.symbol === selectedCoin);
    if (coinData) {
      updateContent("coinName", coinData.symbol);
      updateContent("displayName", coinData.name);
      updateContent("iconUrl", coinData.iconUrl);
      updateContent("price", coinData.price);
    }
  }, [selectedCoin]);

  return (
    <div className="mx-2 flex justify-center">
      <div className="top-panel w-full text-white sm:w-[608px]">
        <div className="px-2 py-4 md:p-4">
          <div className="YourSell">You Sell</div>

          <div className="relative overflow-x-auto mb-5">
            <div className="flex justify-between mt-6">
              <div className="flex">
                <img
                  className="h-auto max-w-full"
                  alt=""
                  width={36}
                  height={36}
                  src={content.iconUrl || frame30} // Default icon if no URL provided
                />
                <select
                  id="currency"
                  className="bg-gray-50 w-20 text-lg md:text-2xl font-semibold bg-transparent text-white-900 border-none"
                  value={selectedCoin}
                  onChange={(e) => setSelectedCoin(e.target.value)}
                >
                  {coinList.map((coin) => (
                    <option key={coin.id} value={coin.symbol}>
                      {coin.symbol}
                    </option>
                  ))}
                </select>
              </div>
              <div  className="w-full flex justify-end">
                <input
                  type="number"
                  value={content.amount && !isNaN(content.amount)
                    ? (parseFloat(content.amount) % 1 === 0
                        ? parseInt(content.amount, 10)
                        : parseFloat(content.amount).toFixed(5))
                    : '0'}
                  onChange={(e) =>
                    updateContent("amount", parseFloat(e.target.value))
                  }
                  className="bg-transparent w-36 mr-2 text-lg md:text-2xl text-white font-semibold border-none "
                />
              </div>
            </div>
            <div className="flex justify-between mt-6">
              <div className="flex">
                <p className="text-[#8C8C8C]">{content.displayName}</p>
              </div>
              <div>
                <p>
                  ${content.price}
                  {/* <span className="text-[#FF0000] ml-1 font-extralight">
                    (-0.29%)
                  </span> */}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
